import React, { Component } from "react";
import { connect } from "react-redux";
import { Autocomplete, FormHelperText, FormLabel, OutlinedInput, TextField } from "@mui/material";

import commonUtilities from "utilities/common";
import { withLocalizer } from "utilities/withLocalizer";
import InputAdornment from "@mui/material/InputAdornment";
import ClearIcon from "@mui/icons-material/Clear";
import { CONFIGURATION } from "utilities/configuration";

class TravelersCount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            noOfAdults: "",
            noOfChildren: ""
        };
    }
    
    componentDidMount() {
        const { productType, deviationTypes, deviationOptionIndex } = this.props;
        let { noOfAdults, noOfChildren } = this.state;
        if(this.props.forDeviationOption) {
            noOfAdults = deviationTypes?.[deviationOptionIndex]?.noOfAdults ?? "";
            noOfChildren = deviationTypes?.[deviationOptionIndex]?.noOfChildren ?? "";
        }
        else {
            noOfAdults = productType?.noOfAdults ?? "";
            noOfChildren = productType?.noOfChildren ?? "";
        }
        this.setState({ noOfAdults, noOfChildren });
    }
  
    handleClear = (isAdult) => {
        let { noOfAdults, noOfChildren } = this.state;
        if(isAdult) {
            noOfAdults = "";
        }
        else {
            noOfChildren = "";
        }
        this.setState({ noOfAdults, noOfChildren });
        if(this.props.forDeviationOption) {
            this.updateDeviationProductType(isAdult, "");
        }
        else {
            this.updateProductType(isAdult, "");
        }
    };
  
    handleChange = (event, isAdult) => {
        const re = /^[0-9\b]+$/;
        if (event.target.value === "" || re.test(event.target.value)) {
            let { noOfAdults, noOfChildren } = this.state;
            if(isAdult) {
                noOfAdults = event.target.value;
            }
            else {
                noOfChildren = event.target.value;
            }
            this.setState({ noOfAdults, noOfChildren });
        }
    };
  
    handleBlur = (event, isAdult) => {

        const re = /^[0-9\b]+$/;
        if (event.target.value === "" || re.test(event.target.value)) {
            if(this.props.forDeviationOption) {
                this.updateDeviationProductType(isAdult, event.target.value);
            }
            else {
                this.updateProductType(isAdult, event.target.value);
            }
        }
    };

    updateProductType = (isAdult, value) => {
        let { productType } = this.props;
        if(isAdult) {
            productType.noOfAdults = value;
        }
        else {
            productType.noOfChildren = value;
        }
								   
        this.setState({ productType });
        this.props.events.handleStep2Data(productType);
        if(isAdult) this.props.events.onNoOfAdultChange();
    };

    updateDeviationProductType = (isAdult, value) => {
        
        let { deviationTypes, deviationOptionIndex } = this.props;
        if(deviationTypes && (deviationOptionIndex !== undefined) && (deviationTypes.length > 0) && deviationTypes[deviationOptionIndex]) {

            let deviationType = deviationTypes[this.props.deviationOptionIndex];
            if(isAdult) {
                deviationType.noOfAdults = value;
            }
            else {
                deviationType.noOfChildren = value;
            }
                                    
            this.setState({ deviationTypes });
            this.props.events.handleStep2DeviationData(deviationTypes);
            if(isAdult) this.props.events.onDeviationNoOfAdultChange();
        }
    };

    render() {
        let { noOfAdults, noOfChildren } = this.state;
        const { error, errors } = this.props;
        
        return (
            <div className="row">
                <div className="col-5 x-full">
                    <div className="row form-control-wrapper">
                        <FormLabel>
                            {this.props.localize("qma-number-of-adults")}
                        </FormLabel>
                        <OutlinedInput
                            fullWidth
                            type="text"
                            data-testid="textinput-noOfAdults"
                            name="noOfAdults"
                            id="outlined-total-number-of-adults"
                            value={noOfAdults}
                            inputProps={{ maxLength: 3 }}
                            onBlur={(event) => this.handleBlur(event, true)}
                            onChange={(event) => this.handleChange(event, true)}
                            error={errors?.noOfAdults?.trim().length > 0}
                            aria-describedby="outlined-total-number-of-adults"
                            endAdornment={
                                CONFIGURATION.APPLY_FIELD_ADORNMENT ? <InputAdornment position="end">
                                    {(noOfAdults && noOfAdults.length > 0 ? <ClearIcon className="clear-icon" onClick={() => this.handleClear(true)} edge="end"/> : null)}
                                </InputAdornment> : null
                            }
                        />
                    </div>
                    <FormHelperText error={errors?.noOfAdults ? true : false}>
                        {errors?.noOfAdults?.trim().length > 0 &&
                            errors?.noOfAdults}
                    </FormHelperText>
                </div>

                <div className="col-5-no-margin-r x-full">
                    <div className="row form-control-wrapper">
                        <FormLabel>
                            {this.props.localize("qma-number-of-children")}
                        </FormLabel>
                        <OutlinedInput
                            fullWidth
                            type="text"
                            name="noOfChildren"
                            id="outlined-total-number-of-children"
                            value={noOfChildren}
                            inputProps={{ maxLength: 3 }}
                            onBlur={(event) => this.handleBlur(event, false)}
                            onChange={(event) => this.handleChange(event, false)}
                            aria-describedby="outlined-total-number-of-children"
                            endAdornment={
                                CONFIGURATION.APPLY_FIELD_ADORNMENT ? <InputAdornment position="end">
                                    {(noOfChildren && noOfChildren.length > 0 ? <ClearIcon className="clear-icon" onClick={() => this.handleClear(false)} edge="end"/> : null)}
                                </InputAdornment> : null
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    
});

export default connect(mapStateToProps)(withLocalizer(TravelersCount));
